export default {
  modalTrigger: {
    id: 'review_summary_legal_modal_trigger',
    defaultMessage: 'How reviews work?',
  },
  modalTitle: {
    id: 'review_summary_legal_modal_title',
    defaultMessage: 'How reviews work',
  },
  modalFirstText: {
    id: 'review_summary_legal_modal_text_first',
    defaultMessage:
      'Customers rate purchases from 1 to 5 stars and leave feedback. Our algorithm then sorts these reviews based on factors like rating and length. You can also rate specific aspects (overall performance, appearance, delivery, etc.) and your overall rating will be the average of these detailed ratings.',
  },
  modalSecondText: {
    id: 'review_summary_legal_modal_text_second',
    defaultMessage:
      'Only Back Market customers can leave a review. We publish all reviews — both positive and negative — without moderation, though defamatory, insulting, or abusive content may be removed by Back Market upon request of any concerned party.',
  },
  modalNote: {
    id: 'review_summary_legal_modal_note',
    defaultMessage: 'Note that reviews are stored for 10 years.',
  },
  modalLegalLink: {
    id: 'review_summary_legal_modal_link',
    defaultMessage: 'Learn more about reviews',
  },
}
